import { render, staticRenderFns } from "./DayDetail.vue?vue&type=template&id=27888d1c&scoped=true&"
import script from "./DayDetail.vue?vue&type=script&lang=js&"
export * from "./DayDetail.vue?vue&type=script&lang=js&"
import style0 from "./DayDetail.vue?vue&type=style&index=0&id=27888d1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27888d1c",
  null
  
)

export default component.exports